export default __webpack_public_path__ + "7c620fdacd65d03b67aada09abb245d7.png";